module.exports = __webpack_public_path__ + "media/images/illustrations/online_quote_small-51f9406d2ab4589d0f8df293a2176a62.svg";